/* =====================================================================
   aw-v3-hero.js — le mouvement du hero mur.

   CE QUE CE SCRIPT NE FAIT PAS : il ne construit rien. Les vignettes, les
   cartes de collection et leurs liens sont rendus par Liquid, côté serveur.
   Sans JavaScript, le mur est figé mais entier, et tous les liens marchent.

   CE QU'IL FAIT :
     1. il duplique chaque colonne une fois, pour fermer la boucle sans saut ;
     2. il écrit un `transform` par colonne et par image, et rien d'autre ;
     3. il met à jour la vitrine au survol ou à l'appui.

   requestAnimationFrame et non animation CSS : la vitesse dépend ici du
   défilement et du survol, elle n'est plus prédéterminée. La boucle se limite
   à une écriture de `transform` par colonne — ni mise en page, ni peinture.
   ===================================================================== */

(function () {
  'use strict';

  var doux = window.matchMedia('(prefers-reduced-motion: reduce)');

  function monte(racine) {
    if (racine.dataset.awv3Monte) return;
    racine.dataset.awv3Monte = '1';

    var mur = racine.querySelector('[data-awv3-mur]');
    var piste = racine.querySelector('.awv3-hero__piste');
    var vitrine = racine.querySelector('.awv3-hero__vitrine');
    var nom = racine.querySelector('[data-awv3-nom]');
    var lienOeuvre = racine.querySelector('[data-awv3-lien-oeuvre]');
    var lienColl = racine.querySelector('[data-awv3-lien-collection]');
    var mode = racine.querySelector('[data-awv3-mode]');
    if (!mur || !piste) return;

    var survolPossible = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    /* « survolez » sur un écran tactile est une instruction impossible à suivre */
    if (mode && !survolPossible && mode.dataset.tactile) {
      mode.textContent = mode.dataset.tactile;
    }

    /* ---------------- la vitrine ---------------- */
    var vues = vitrine ? vitrine.querySelectorAll('.awv3-hero__vue') : [];
    var devant = vues[0];
    var derriere = vues[1];
    var encours = null;
    var cache = {};

    function espace(n) {
      return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    function montre(tuile) {
      if (!tuile || tuile === encours) return;
      encours = tuile;

      /* LE TEXTE N'ATTEND PAS LA PHOTO. En liant le titre au chargement de
         l'image, un appui reste sans effet visible pendant deux à quatre
         dixièmes de seconde. Le nom et les liens partent tout de suite. */
      if (nom) nom.textContent = tuile.dataset.nom || '';
      if (lienOeuvre) lienOeuvre.href = tuile.getAttribute('href');
      if (lienColl && tuile.dataset.collectionUrl) {
        lienColl.href = tuile.dataset.collectionUrl;
        lienColl.textContent =
          'Voir les ' + espace(tuile.dataset.collectionN) + ' tableaux ' + tuile.dataset.collection;
      }

      var src = tuile.dataset.vue;
      if (!src || !derriere) return;

      var poser = function () {
        if (encours !== tuile) return;
        derriere.src = src;
        derriere.alt = tuile.dataset.nom || '';
        derriere.classList.add('awv3-hero__vue--devant');
        if (devant) devant.classList.remove('awv3-hero__vue--devant');
        var t = devant; devant = derriere; derriere = t;
      };

      if (cache[src]) return poser();
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { cache[src] = 1; poser(); };
      im.onerror = function () { cache[src] = 1; };
      im.src = src;
    }

    /* ---------------- les colonnes ---------------- */

    /* Une colonne en `display:none` télécharge quand même ses images : le
       navigateur ne traite `loading="lazy"` que pour ce qu'il met en page.
       Les colonnes au-delà du réglage mobile arrivent donc sans `src` ; on
       la leur donne quand elles sont effectivement affichées — et seulement
       alors. */
    function promeut() {
      [].forEach.call(piste.querySelectorAll('.awv3-hero__colonne'), function (col) {
        if (window.getComputedStyle(col).display === 'none') return;
        [].forEach.call(col.querySelectorAll('img[data-src]'), function (im) {
          im.src = im.dataset.src;
          im.removeAttribute('data-src');
        });
      });
    }

    var colonnes = [];
    [].forEach.call(piste.querySelectorAll('.awv3-hero__colonne'), function (col) {
      var file = col.querySelector('.awv3-hero__file');
      if (!file || !file.children.length) return;

      if (!doux.matches) {
        /* un second exemplaire bout à bout : la boucle se referme sans saut,
           puisque le défilement s'arrête à la moitié exacte. Ces copies ne
           coûtent aucun octet — mêmes URL, donc même cache. */
        var copies = [].map.call(file.children, function (n) {
          var c = n.cloneNode(true);
          c.classList.add('awv3-hero__doublon');
          c.setAttribute('aria-hidden', 'true');
          c.tabIndex = -1;
          var img = c.querySelector('img');
          if (img) img.alt = '';
          return c;
        });
        copies.forEach(function (c) { file.appendChild(c); });
      }

      colonnes.push({
        el: file,
        pos: 0,
        v: parseFloat(file.dataset.vitesse) || 26,
        sens: parseFloat(file.dataset.sens) || 1,
        mult: 1,
        cible: 1,
        H: 0
      });
    });
    if (!colonnes.length) return;

    /* L'EN-TÊTE DU THÈME EST `position: fixed` — 157 px, z-index 600, mesuré le
       19 octobre. Il ne pousse donc rien : il RECOUVRE. Prendre la position du
       hero dans le document donnait 0, et le titre se retrouvait caché dessous.
       Ce qu'il faut relever, c'est la hauteur de ce qui est épinglé en haut de
       l'écran, et le dégager par un retrait — pas en rognant 100svh. */
    function mesureEntete() {
      var h = 0;
      if (document.elementsFromPoint) {
        var pile = document.elementsFromPoint(Math.round(window.innerWidth / 2), 2) || [];
        for (var i = 0; i < pile.length; i++) {
          var e = pile[i];
          if (e === document.body || e === document.documentElement) continue;
          if (racine.contains(e)) continue;
          var c = window.getComputedStyle(e);
          if (c.position !== 'fixed' && c.position !== 'sticky') continue;
          var r = e.getBoundingClientRect();
          if (r.top <= 2 && r.height > h && r.height < window.innerHeight * 0.5) h = r.height;
        }
      }
      racine.style.setProperty('--awv3-entete', Math.round(h) + 'px');
    }

    function mesure() {
      mesureEntete();
      promeut();
      colonnes.forEach(function (c) { c.H = c.el.scrollHeight / 2 || 1; });
    }
    mesure();
    window.addEventListener('resize', mesure);
    /* Le script est `defer` : au moment où il court, l'en-tête n'a pas
       toujours sa hauteur définitive (polices, barre d'annonce, applications).
       Mesuré le 19 octobre : 0 px au montage contre 160 px une fois la page
       chargée. On relève donc trois fois — au montage, à l'image suivante,
       et au `load`. */
    requestAnimationFrame(mesureEntete);
    window.addEventListener('load', mesure);

    /* ---------------- choix d'une vignette ---------------- */
    var marquee = null, relache = 0;
    var ralentit = racine.dataset.survolRalentit === '1';
    var facteur = (parseFloat(racine.dataset.ralenti) || 16) / 100;

    function colonneDe(tuile) {
      var col = tuile.closest('.awv3-hero__colonne');
      if (!col) return null;
      var i = [].indexOf.call(col.parentNode.children, col);
      return colonnes[i] || null;
    }

    function vise(tuile, actif) {
      if (!ralentit) return;
      var c = colonneDe(tuile);
      if (c) c.cible = actif ? facteur : 1;
    }

    function toutesAuRepos() {
      colonnes.forEach(function (c) { c.cible = 1; });
    }

    function choisit(tuile) {
      if (marquee) marquee.removeAttribute('aria-current');
      tuile.setAttribute('aria-current', 'true');
      marquee = tuile;
      montre(tuile);
    }

    if (!doux.matches && survolPossible) {
      mur.addEventListener('pointerover', function (e) {
        if (e.pointerType !== 'mouse') return;
        var t = e.target.closest('.awv3-hero__tuile');
        if (!t) return;
        toutesAuRepos();
        vise(t, true);
        choisit(t);
      });
      mur.addEventListener('pointerleave', toutesAuRepos);
    }

    mur.addEventListener('focusin', function (e) {
      var t = e.target.closest('.awv3-hero__tuile');
      if (t) choisit(t);
    });

    /* AU DOIGT, DEUX APPUIS. La vignette étant un lien, le premier appui
       ouvrirait la fiche produit : personne ne verrait ni la sélection, ni la
       colonne ralentir. Premier appui : on choisit. Deuxième appui sur la même
       vignette : on ouvre.

       La sélection se fait au RELÂCHEMENT et non au clic : selon le navigateur
       et le mode d'émulation, le clic synthétisé à partir du tap arrive ou
       n'arrive pas. Le clic qui suivrait est annulé. */
    var premierAppui = null, depart = null;

    if (!doux.matches && !survolPossible) {
      mur.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse') return;
        depart = { x: e.clientX, y: e.clientY };
      }, { passive: true });

      mur.addEventListener('pointerup', function (e) {
        if (e.pointerType === 'mouse') return;
        /* un doigt qui a glissé voulait faire défiler, pas choisir */
        if (depart && Math.abs(e.clientY - depart.y) + Math.abs(e.clientX - depart.x) > 12) {
          depart = null;
          return;
        }
        depart = null;
        var t = e.target.closest('.awv3-hero__tuile');
        if (!t) return;
        if (t.getAttribute('aria-current') === 'true') { premierAppui = null; return; }
        premierAppui = t;
        toutesAuRepos();
        vise(t, true);
        choisit(t);
        clearTimeout(relache);
        relache = setTimeout(toutesAuRepos, 2600);
      }, { passive: true });
    }

    mur.addEventListener('click', function (e) {
      if (survolPossible || doux.matches) return;
      var t = e.target.closest('.awv3-hero__tuile');
      if (!t) return;
      if (t === premierAppui) { e.preventDefault(); premierAppui = null; return; }
      /* ceinture et bretelles : si le navigateur n'a pas livré de pointerup,
         ce clic-ci est le premier appui */
      if (t.getAttribute('aria-current') !== 'true') {
        e.preventDefault();
        toutesAuRepos();
        vise(t, true);
        choisit(t);
        clearTimeout(relache);
        relache = setTimeout(toutesAuRepos, 2600);
      }
    });

    if (doux.matches) return;   /* mur figé : plus rien à animer */

    /* ---------------- la boucle ---------------- */
    var boost = 0, dernier = 0, tourne = false;

    function image(t) {
      if (!dernier) dernier = t;
      var dt = Math.min((t - dernier) / 1000, 0.05);
      dernier = t;

      boost *= Math.pow(0.90, dt * 60);
      if (boost < 0.5) boost = 0;

      for (var i = 0; i < colonnes.length; i++) {
        var c = colonnes[i];
        c.mult += (c.cible - c.mult) * Math.min(1, dt * 9);
        c.pos += (c.v + boost) * c.mult * dt;
        c.pos %= c.H;
        if (c.pos < 0) c.pos += c.H;
        var y = c.sens > 0 ? -c.pos : c.pos - c.H;
        c.el.style.transform = 'translate3d(0,' + y + 'px,0)';
      }
      requestAnimationFrame(image);
    }

    /* ---------------- l'accélération au défilement ----------------
       Écouteurs PASSIFS, aucun preventDefault : le défilement de la page
       n'est jamais confisqué. On ne fait qu'ajouter de la vitesse, et elle
       retombe toute seule. */
    function pousse(d) {
      var r = mur.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      boost = Math.min(boost + Math.abs(d) * 0.9, 900);
    }

    var yPage = window.scrollY;
    window.addEventListener('scroll', function () {
      pousse(window.scrollY - yPage);
      yPage = window.scrollY;
    }, { passive: true });

    mur.addEventListener('wheel', function (e) { pousse(e.deltaY); }, { passive: true });

    var yDoigt = null;
    mur.addEventListener('touchstart', function (e) {
      yDoigt = e.touches[0].clientY;
    }, { passive: true });
    mur.addEventListener('touchmove', function (e) {
      if (yDoigt === null) return;
      var y = e.touches[0].clientY;
      pousse(y - yDoigt);
      yDoigt = y;
    }, { passive: true });
    mur.addEventListener('touchend', function () { yDoigt = null; }, { passive: true });

    /* une boucle qui tourne dans un onglet caché ne sert personne */
    document.addEventListener('visibilitychange', function () { dernier = 0; });

    if (!tourne) { tourne = true; requestAnimationFrame(image); }
  }

  function demarre() {
    [].forEach.call(document.querySelectorAll('[data-awv3="hero-mur"]'), monte);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarre);
  } else {
    demarre();
  }

  /* l'éditeur de thème remonte la section à chaque réglage modifié */
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-awv3="hero-mur"]');
    if (r) monte(r);
  });
})();
